<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex v-for="item in list" v-bind:key="item._id" xs12 sm12 md6 lg4 xl3>
          <v-hover>
            <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
              <v-card-title primary-title>{{item.name}}</v-card-title>
              <v-card-text>
                <p>Phone: {{item.phone || "NaN"}}</p>
                <!-- <p>Events: NaN</p> -->
              </v-card-text>
              <v-card-actions>
                <v-layout align-center justify-space-between row>
                  <v-btn text color="red lighten-1" @click="removeGroup(item)">Remove</v-btn>
                  <v-btn text color="grey darken-3" @click="editGroup(item)">Edit</v-btn>
                  <!-- <v-spacer/> -->
                  <v-btn text color="blue" @click="eventClick(item)">Dashboard</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
    <v-btn fab bottom right color="light-blue darken-1" dark fixed @click="dialog = !dialog">
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title">Create Group</v-card-title>

        <v-container grid-list-sm class="pa-4">
          <v-layout row wrap>
            <v-flex xs12 align-center justify-space-between>
              <v-layout align-center>
                <v-text-field prepend-icon="business" placeholder="Name" v-model="newgroup.name"></v-text-field>
              </v-layout>
            </v-flex>
            <!-- <v-flex xs12>
              <v-text-field prepend-icon="message" placeholder="message" v-model="newgroup.message"></v-text-field>
            </v-flex>-->
          </v-layout>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="cancel">Cancel</v-btn>

          <v-btn text color="primary" @click="addGroup">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-loading :dialog="isLoading" />
  </div>
</template>
<script>
import groupService from "@/services/groups/group";
export default {
  data: () => ({
    dialog: false,
    picker: new Date().toISOString().substr(0, 10),
    time: null,
    e1: 0,
    list: [],
    newgroup: {
      _id:null,
      name: ""
    },
    default:{
      _id:null,
      name: ""
    },
    isLoading: false
  }),
  methods: {
    initialize() {
      this.isLoading = true;
      groupService
        .getGroups()
        .then(data => {
          this.newgroup = JSON.parse(JSON.stringify(this.default));
          this.list = data;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    addGroup() {
      this.dialog = false;
      this.isLoading = true;
      if(this.newgroup._id != null){
        groupService.editGroup(this.newgroup._id,this.newgroup.name)
        .then(data=>{
          this.isLoading = false;
          this.initialize();
        })
        .catch(err=>{
          this.isLoading = false;
          alert("Could not update the group");
        })
        return;
      }
      groupService
        .addGroup(this.newgroup.name)
        .then(data => {
          this.isLoading = false;
          this.cancel();
        })
        .catch(err => {
          this.isLoading = false;
          console.log("Error", err);
        });
    },
    removeGroup(item) {
      if (
        !confirm(
          `Are you sure you want to delete ${item.name}? \n\nThis cannot be undone.`
        )
      ) {
        return;
      }
      this.isLoading = true;
      groupService
        .removeGroup(item._id)
        .then(data => {
          this.isLoading = false;
          this.initialize();
        })
        .catch(err => {
          this.isLoading = false;
          alert(`Could not delete ${item.name}. \n\nTry again later.`);
        });
    },
    editGroup(item){
      this.newgroup._id = item._id;
      this.newgroup.name = item.name;
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.newgroup = {
        name: "",
        message: ""
      };
      this.initialize();
    },
    eventClick(group) {
      this.$router.push({ name: "events", params: { id: group._id } });
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>
